// Source of the "stock"/factory catalogs (samples, soundfonts, presets).
// The concrete implementation lives in the openDAW app and talks to the
// openDAW servers, so it is injected here instead of referenced directly.
// A standalone SDK consumer that never installs a provider stays local-only.
export var FactoryCatalog;
(function (FactoryCatalog) {
    const Empty = {
        samples: async () => [],
        soundfonts: async () => [],
        presets: async () => []
    };
    let current = Empty;
    FactoryCatalog.install = (provider) => { current = provider; };
    FactoryCatalog.get = () => current;
})(FactoryCatalog || (FactoryCatalog = {}));
